var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SpeakerCard } from "../../ui/SpeakerCard/SpeakerCard";
export var SpeakerDetailsModal = function (speaker) {
    return _jsx(SpeakerCard, __assign({}, speaker, { name: "".concat(speaker.firstname, " ").concat(speaker.lastname), avatar: speaker.media_url, descriptionVisible: true }));
};
export var getSpeakerDetailsModalProps = function () {
    return {};
};
